export default __webpack_public_path__ + "static/form-is-there-bb67ddcbe9b3c1d0d339ab6011110b85.svg";